//@ts-check
import { myxchngApiClient } from '../../utils/RequestClient';

/**
 *
 * @param {object} params
 * @param {string} params.token
 * @param {AbortSignal} [params.signal]
 * @returns {Promise<import('@action-types/userEntitlement').UserEntitlementsResponse>}
 * @throws {import('@action-types/RequestError').RequestError<import('@action-types/ecApp').MyxchngApiErrorResponse>}
 */
const getUserEntitlements = async ({ signal, token }) => {
  const headers = new Headers({ authorization: `Bearer ${token}` });
  const { jsonResponse } = await myxchngApiClient.fetch({
    endpoint: `/v1/entitlements`,
    requestOptions: {
      signal,
      headers,
    },
  });
  return jsonResponse;
};

export default getUserEntitlements;
